import React, { useContext, useEffect, useState } from "react";
import GlobalContext from "../connections/GlobalContext";
import { Table, Modal, Button, Label, TextInput } from "flowbite-react";
import Swal from "sweetalert2";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";
import Select from "react-select";


import engineGif from "../image/engine.gif";

const SpareLogDetails = ({ estimate_id, setShowTable, refresh }) => {
  const { globalValue } = useContext(GlobalContext);
  const [spareRecords, setSpareRecords] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSpare, setSelectedSpare] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [tempService, setTempService] = useState("");
  const [enteredQuantity, setEnteredQuantity] = useState(0);
  const [quantityWarning, setQuantityWarning] = useState(false);
  const [temp_brand, setTemp_brand] = useState("");
  const [temp_model, setTemp_model] = useState("");
  const [loading, setLoading] = useState(false);
  const [staff_id, setStaff_id] = useState("");
  const [staffs_, setStaffs_] = useState([]);

  // Return modal states
  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const [returnQuantity, setReturnQuantity] = useState(0);
  const [returnQuantityWarning, setReturnQuantityWarning] = useState(false);
  const [selectedReturnSpare, setSelectedReturnSpare] = useState(null);
  const [selectedReturnRecord, setSelectedReturnRecord] = useState(null);
  const [returnStaffId, setReturnStaffId] = useState("");

  const fetchStaffs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/staffs`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      const staffOptions = response.data
        .filter((staff) => staff[6][0] !== "superadmin")
        .map((staff) => ({
          value: staff[2],
          label: staff[2],
        }));
      setStaffs_(staffOptions);
    } catch (error) {
      console.error("Error fetching staff data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
    fetchStaffs();
    // eslint-disable-next-line
  }, []);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spare_record`,
        { estimate_id },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      setSpareRecords(response.data);
      return response.data;
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "Failed to fetch data",
        text: "Please try again later.",
      });
      return [];
    } finally {
      setLoading(false);
    }
  };

  const spareFixedQuantity = () =>
    selectedSpare ? selectedSpare["Available Quantity"] : 0;

  const handleTakeButtonClick = (spare, record, brand, model1) => {
    setSelectedSpare(spare);
    setSelectedRecord(record);
    setEnteredQuantity(0);
    setQuantityWarning(false);
    setModalOpen(true);
    setTemp_brand(brand);
    setTemp_model(model1);
  };

  const handleQuantityChange = (e) => {
    const value = parseFloat(e.target.value);
    setEnteredQuantity(isNaN(value) ? 0 : value);
    setQuantityWarning(value > spareFixedQuantity());
  };


  const handleSpareTaken = async (spare_id, quantity, est_id, service_id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spare_taken`,
        {
          spare_id,
          quantity,
          est_id,
          service_id,
          staff_id: sessionStorage.getItem("temp_user"),
          temp_brand,
          temp_model,
          mechanic: staff_id,
          admin: "admin",
        },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data === "success") {
        Swal.fire({ icon: "success", title: "Spare Taken Successfully" });
        fetchRecords();
      } else {
        Swal.fire({ icon: "warning", title: response.data.message });
      }
    } catch (error) {
      Swal.fire({ icon: "warning", title: "Spare not Taken" });
    } finally {
      setLoading(false);
    }
    setModalOpen(false);
  };

  // ---- Return modal logic ----
  const handleReturnButtonClick = (spare, record, brand, model1) => {
    setSelectedReturnSpare(spare);
    setSelectedReturnRecord(record);
    setReturnQuantity(0);
    setReturnQuantityWarning(false);
    setReturnStaffId("");
    setTemp_brand(brand);
    setTemp_model(model1);
    setReturnModalOpen(true);
    setTempService(spare["Service ID"]);
  };

  const handleReturnQuantityChange = (e) => {
    const value = parseFloat(e.target.value);
    setReturnQuantity(isNaN(value) ? 0 : value);

    const maxUsed = selectedReturnSpare ? selectedReturnSpare["Quantity Used"] : 0;
    setReturnQuantityWarning(value > maxUsed);
  };


  const handleSpareReturned = async (spare_id, quantity, est_id, service_id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spare_return`,
        {
          spare_id,
          quantity,
          est_id,
          service_id,
          staff_id: sessionStorage.getItem("temp_user"),
          temp_brand,
          temp_model,
          mechanic: returnStaffId,
          admin: "admin",
        },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data === "success") {
        Swal.fire({ icon: "success", title: "Spare Returned Successfully" });
        fetchRecords();
      } else {
        Swal.fire({ icon: "warning", title: response.data.message });
      }
    } catch (error) {
      Swal.fire({ icon: "warning", title: "Spare not Returned" });
    } finally {
      setLoading(false);
    }
    setReturnModalOpen(false);
  };

  return (
    <div>
      <div className="overflow-auto">
        <button
          onClick={() => {
            setShowTable(false);
            refresh();
          }}
          className="flex items-center bg-gray-500 p-2 rounded-md shadow-md text-gray-100 hover:bg-gray-600 me-4"
        >
          <FaArrowLeft className="w-5 h-5 mr-2" />
        </button>

        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        {spareRecords.length > 0 ? (
          spareRecords.map((record) => (
            <div key={record.log_id} className="mb-4">
              {record.services.map((service) => (
                <React.Fragment key={service}>
                  <p>
                    {
                      record.service_details.find(
                        (ser) => ser.service_id === service
                      )?.service_name || "Unknown Service"
                    }
                  </p>
                  <p>{service}</p>
                  <table className="w-full border border-gray-300 shadow-md rounded-lg overflow-hidden">
                    <thead className="bg-gray-200 text-gray-900 text-sm font-semibold">
                      <tr>
                        <th className="p-4 text-left border-b border-gray-300">
                          Spare Name
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Brand
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Model
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Maximum Qty
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Qty Used
                        </th>
                        <th className="p-4 text-left text-red-500 border-b border-gray-300">
                          Available Qty (Master)
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Price
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-300">
                      {record.spares.map(
                        (spare, index) =>
                          service === spare["Service ID"] && (
                            <tr
                              key={index}
                              className="hover:bg-gray-100 transition duration-200"
                            >
                              <td className="p-4 border-r border-gray-300">
                                {spare["Spare Name"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["brand"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["model1"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["Actual Quantity"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["Quantity Used"]}
                              </td>
                              <td className="p-4 text-red-500 font-bold border-r border-gray-300">
                                {spare["Original Quantity"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["Price"]}
                              </td>
                              <td className="p-4 flex gap-2">
                                <button
                                  className="px-4 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition duration-200"
                                  onClick={async () => {
                                    const updatedRecords = await fetchRecords();
                                    const updatedRecord = updatedRecords.find(
                                      (r) => r.log_id === record.log_id
                                    );
                                    const updatedSpare =
                                      updatedRecord?.spares.find(
                                        (s) =>
                                          s["Spare ID"] === spare["Spare ID"]
                                      );
                                    setTempService(spare["Service ID"]);
                                    setStaff_id("");
                                    setTimeout(
                                      () =>
                                        handleTakeButtonClick(
                                          updatedSpare,
                                          updatedRecord,
                                          spare["brand"],
                                          spare["model1"]
                                        ),
                                      500
                                    );
                                  }}
                                >
                                  Take
                                </button>
                                <button
                                  className="px-4 py-2 bg-green-600 text-white font-medium rounded-lg shadow-md hover:bg-green-700 transition duration-200"
                                  onClick={async () => {
                                    const updatedRecords = await fetchRecords();
                                    const updatedRecord = updatedRecords.find(
                                      (r) => r.log_id === record.log_id
                                    );
                                    const updatedSpare =
                                      updatedRecord?.spares.find(
                                        (s) =>
                                          s["Spare ID"] === spare["Spare ID"]
                                      );
                                    setTempService(spare["Service ID"]);
                                    setReturnStaffId("");
                                    setTimeout(
                                      () =>
                                        handleReturnButtonClick(
                                          updatedSpare,
                                          updatedRecord,
                                          spare["brand"],
                                          spare["model1"]
                                        ),
                                      500
                                    );
                                  }}
                                >
                                  Return
                                </button>
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </React.Fragment>
              ))}
            </div>
          ))
        ) : (
          <p>Loading records...</p>
        )}
      </div>

      {/* ---- Take Modal ---- */}
      {modalOpen && selectedSpare && selectedRecord && (
        <Modal show={modalOpen} onClose={() => setModalOpen(false)}>
          <Modal.Header className="flowbite-modal-h">Take Spare</Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="space-y-4">
              <p>
                Spare Name: <b>{selectedSpare["Spare Name"]}</b>
              </p>
              <p>
                Fixed Quantity: <b>{spareFixedQuantity()}</b>
              </p>
              <div>
                <Label htmlFor="quantity">Enter Quantity:</Label>
                <TextInput
                  id="quantity"
                  type="number"
                  value={enteredQuantity}
                  onChange={handleQuantityChange}
                  min={0}
                  max={spareFixedQuantity()}
                  color="white"
                  step="any"
                />
                {quantityWarning && (
                  <p className="text-red-500 text-sm mt-1">
                    Entered quantity exceeds the fixed quantity.
                  </p>
                )}
              </div>

              <Select
                className="w-full"
                classNamePrefix="react-select"
                options={staffs_}
                value={staffs_.find((staff) => staff.value === staff_id) || null}
                onChange={(selected) =>
                  setStaff_id(selected ? selected.value : "")
                }
                placeholder="Select Staff"
                isSearchable
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />

            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-h">
            <Button
              disabled={
                enteredQuantity > spareFixedQuantity() ||
                enteredQuantity <= 0 ||
                !staff_id
              }
              onClick={() =>
                handleSpareTaken(
                  selectedSpare["Spare ID"],
                  enteredQuantity,
                  selectedRecord.estimate_id,
                  tempService
                )
              }
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* ---- Return Modal ---- */}
      {returnModalOpen && selectedReturnSpare && selectedReturnRecord && (
        <Modal show={returnModalOpen} onClose={() => setReturnModalOpen(false)}>
          <Modal.Header className="flowbite-modal-h">Return Spare</Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="space-y-4">
              <p>
                Spare Name: <b>{selectedReturnSpare["Spare Name"]}</b>
              </p>
              <p>
                Used Quantity: <b>{selectedReturnSpare["Quantity Used"]}</b>
              </p>
              <div>
                <Label htmlFor="quantity-return">Enter Quantity to Return:</Label>
                <TextInput
                  id="quantity-return"
                  type="number"
                  value={returnQuantity}
                  onChange={handleReturnQuantityChange}
                  min={0}
                  max={selectedReturnSpare["Quantity Used"]}
                  step="any"
                  color="white"
                />
                {returnQuantityWarning && (
                  <p className="text-red-500 text-sm mt-1">
                    Entered quantity exceeds the used quantity.
                  </p>
                )}
              </div>
              <select
                className="block w-full p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={returnStaffId}
                onChange={(e) => setReturnStaffId(e.target.value)}
              >
                <option value="" disabled>
                  Select Staff
                </option>
                {staffs_.map((staff) => (
                  <option key={staff.value} value={staff.value}>
                    {staff.label}
                  </option>
                ))}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-h">
            <Button
              disabled={
                returnQuantity >
                (selectedReturnSpare ? selectedReturnSpare["Quantity Used"] : 0) ||
                returnQuantity <= 0 ||
                !returnStaffId
              }
              onClick={() =>
                handleSpareReturned(
                  selectedReturnSpare["Spare ID"],
                  returnQuantity,
                  selectedReturnRecord.estimate_id,
                  tempService
                )
              }
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default SpareLogDetails;
